import { useEffect } from 'react';
import { seoConfig, getCanonicalUrl } from '../../config/seo';

function upsertMeta(attr, key, value) {
  if (!value) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export default function PageMeta({
  title,
  description,
  pathname,
  ogImage,
  noindex = false,
}) {
  const canonical = getCanonicalUrl(pathname);
  const imageUrl = ogImage
    ? ogImage.startsWith('http')
      ? ogImage
      : `${seoConfig.siteUrl}${ogImage}`
    : `${seoConfig.siteUrl}${seoConfig.defaultOgImage}`;

  useEffect(() => {
    document.title = title;

    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
    upsertLink('canonical', canonical);

    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', seoConfig.siteName);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:image', imageUrl);
    upsertMeta('property', 'og:locale', seoConfig.locale);

    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', imageUrl);
    if (seoConfig.twitterHandle) {
      upsertMeta('name', 'twitter:site', seoConfig.twitterHandle);
    }
  }, [title, description, canonical, imageUrl, noindex]);

  return null;
}
